/**
 * @author NikolaV
 */
import { ProjectCodesService } from '@shared/services/ProjectCodesService';
import * as React from 'react';
import { DateTimeSpan } from '../.././ui-react/UtilComponents';


export class LogpointProps extends React.Component<{
    logpoint: ILogpoint,
}> {
    render() {
        if (!this.props.logpoint) return null;

        const ld: ILogpoint = this.props.logpoint;
        const modelName: string = ld.model ? ld.model.name : __('tablet.unknown_js');
        const folderName: string = ld.folderName ? ld.folderName : __('tablet.unknown_js');
        const distanceToModel = Math.round(Math.sqrt(ld.modelDeltaY * ld.modelDeltaY + ld.modelDeltaX * ld.modelDeltaX) * 1000) / 1000;
        const distanceStr: string = ld.model && distanceToModel ? __('tablet.distance_to_model_js') + ': ' + distanceToModel + "m" : "";
        const alignmentName: string = ld.alignment ? ld.alignment.name : __('tablet.unknown_js');

        let typeDesc: string = __('logpoints.type.VEHICLE_js');
        if (ld.type) {
            typeDesc = __('logpoints.type.' + ld.type + '_js');

            if (ld.status === 'SUPERVISOR') {
                typeDesc += ', ' + __('logpoints.status.' + ld.status + '_js');
            }
        }

        return (
            <div>
                {typeof ld.linecode == 'undefined' ? null :
                    <div>{__('js_logpoints.column_linecode') + ': ' + ld.linecode}</div>
                }
                <div>{__('tablet.number_js') + ': ' + ld.pointNumber}</div>
                {typeof ld.pointName == 'undefined' ? null :
                    <div>{__('tablet.name_js') + ': ' + ld.pointName}</div>
                }
                <div>
                    {__('tablet.code_js') + ': '} <ProjectCodesService.ProjectCodeSpan code={ld.codeNumber}/>
                </div>
                <br/>

                <div>{__('general.folder') + ': ' + folderName}</div>
                <div>{__('tablet.model_js') + ': ' + modelName}</div>
                <div>{__('js_logpoints.column_alignment') + ': ' + alignmentName}</div>
                <div>{__('js_logpoints.column_station') + ': ' + (Math.round(ld.station * 1000) / 1000)}</div>
                <div>{__('tablet.stationequation_js') + ': ' + (ld.stationEquation ?? '')}</div>
                {$.isNumeric(ld.b) && ld.alignment ? <div>{__('tablet.sidemeasure_js') + ': ' + ld.b + 'm'}</div> : null}
                {ld.hasOwnProperty('activeLayer') ? <div>{__('js_logpoints.column_surfacecode') + ': ' + ld.activeLayer}</div> : null}
                <div>{distanceStr}</div>
                <div className='flex-row'>
                    {$.isNumeric(ld.modelDeltaX) && ld.model ? <div>{__('tablet.dx_js') + ': ' + (Math.round(ld.modelDeltaX * 1000) / 1000)}</div> : null}
                    {$.isNumeric(ld.modelDeltaY) && ld.model ?
                        <div style={{ marginLeft: 15 }}>{__('tablet.dy_js') + ': ' + (Math.round(ld.modelDeltaY * 1000) / 1000)}</div> : null}
                    {$.isNumeric(ld.modelDeltaZ) && ld.model ?
                        <div style={{ marginLeft: 15 }}>{__('tablet.dz_js') + ': ' + (Math.round(ld.modelDeltaZ * 1000) / 1000)}</div> : null}
                </div>
                <br/>
                <div>x: {ld.x}</div>
                <div>y: {ld.y}</div>
                <div>z: {ld.z}</div>
                <br/>
                <div>{__('tablet.date_js') + ': '}<DateTimeSpan timestamp={ld.timestamp}/></div>
                <div>{__('tablet.logpoint_type_js') + ': ' + typeDesc}</div>
                {ld.vehicleName ? <div>{__('tablet.vehicle_js') + ': ' + ld.vehicleName}</div> : null}
                {ld.creator ? <div>{__('general.user') + ': ' + ld.creator.username}</div> : null}
            </div>
        );
    }

}
